<template>
  <config-pro-plus-base
    :plan-details-label="$t('billing.zone.explore_other_plans_edit')"
    :show-full-comparison-dialog="showFullComparisonDialog"
    show-plan-details>
    <template #config>
      <edit-us />
    </template>
  </config-pro-plus-base>
</template>

<script>
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import EditUs from './edit-us.vue';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';

export default {
  components: { EditUs, ConfigProPlusBase },
  mixins: [ConfigMixin],
};
</script>
